// controls/radio.js — version refactorisée avec OptionsEditor
import React from "react";
import CommonControls from "./inc/Common";
import OptionsEditor from "./inc/OptionsEditor";

/**
 * Création d’un champ "radio group"
 */
export function createRadioField() {
  return {
    type: "string",
    title: "Boutons radio",
    "x-ui": "radio",
    "x-required": true,
    "x-show-if": [],
    enum: [""],
    "x-options": [
      { text: "Oui", value: "oui" },
      { text: "Non", value: "non" },
    ],
  };
}

/**
 * Éditeur du champ radio group
 */
export function EditRadioField({ field, onChange }) {
  const handleOptionsChange = (options) => {
    const updatedField = {
      ...field,
      "x-options": options,
      enum: options.map((o) => o.value),
    };
    onChange(updatedField);
  };

  return (
    <>
      <CommonControls field={field} onChange={onChange} />
      <OptionsEditor
        initialOptions={field["x-options"]}
        onChange={handleOptionsChange}
        label="Boutons radio"
      />
    </>
  );
}

export const editRadioField = (props) => <EditRadioField {...props} />;

/* =========================================================
   🧩 FRONT — rendu du champ boutons radio
   ========================================================= */
export const RenderRadioField = ({
  field,
  value,
  onChange,
  className,
  isReadOnly,
  errors     // <--- AJOUT
}) => {

  const options = field["x-options"] || [];
  const isRequired =
    field["x-effective-required"] === true ||
    field["x-required"] === true;

  // nom unique (react radio group)
  const name =
    field.name || field.id || "radio_" + Math.random().toString(36).substring(2, 7);

  // classe d’erreur à appliquer
  const invalidClass = errors ? "is-invalid" : "";

  return (
    <div
      className={`
        ${isRequired ? "fb-required" : ""}
        fb-field fb-radio
        ${field["x-bloc-class"] || ""}
        ${className || ""}
        ${invalidClass}
      }
      `}
    >

      {/* Label principal */}
      {field.title && (
        <label className={`form-label d-block`}>
          {field.title}
        </label>
      )}

      {/* Groupe de radios */}
      <div className={`d-flex flex-column gap-1 ${field["x-control-class"] || ""}`}>
        {options.map((opt, i) => (
          <div key={i} className="form-check">

            <input
              className={`form-check-input`}
              type="radio"
              name={name}
              id={`${name}_${i}`}
              value={opt.value}
              checked={value === opt.value}
              readOnly={isReadOnly}
              disabled={isReadOnly}
              onChange={() => onChange?.(opt.value)}
            />

            <label
              className={`form-check-label`}
              htmlFor={`${name}_${i}`}
            >
              {opt.text}
            </label>

          </div>
        ))}
      </div>

      {/* Message d’erreur */}
      {/* errors && (
        <div className="invalid-feedback d-block mt-1">
          {errors}
        </div>
      ) */}

    </div>
  );
};
